<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="checkDialogFormVisible({}, 'CREATE')"
        >新增</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all
    >
      <el-table-column prop="id" label="编号" sortable width="100"> </el-table-column>
      <el-table-column align="center" prop="name" label="等级名称" sortable> </el-table-column>
      <el-table-column align="center" prop="grade" label="等级" width="90"> </el-table-column>
      <el-table-column
        align="center"
        prop="yqHotcastAmount"
        label="累计爆单商品消费金额"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="yqAllcastAmount"
        label="累计所有商品消费金额"
      ></el-table-column>
      <el-table-column align="center" prop="yqTeamAmount" label="团队业绩金额"></el-table-column>
      <el-table-column
        align="center"
        prop="yqSameGrade"
        label="直推下线达到平级人数"
      ></el-table-column>
      <el-table-column align="center" prop="yqRelation" label="多个升级条件的关系">
        <template slot-scope="scope">
          <span>{{ getValue(UPGRADES_CONDITIONS, scope.row.yqRelation) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="100"
      >
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="checkDialogFormVisible(scope.row, 'UPDATE')"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getGradeList } from "@/api/system.js";
import { getValue, UPGRADES_CONDITIONS } from "@/utils/enumUtile";
import { formatApiDate } from "@/utils/utils";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    getValue() {
      return getValue;
    },
    UPGRADES_CONDITIONS() {
      return UPGRADES_CONDITIONS;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {}
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    /**
     * 查询用户列表
     */
    getList() {
      this.listLoading = true;
      getGradeList(this.listQuery)
        .then(response => {
          this.list = response.data || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 切换状态
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(editObj = {}, type) {
      if (type === "UPDATE") {
        this.$router.push({ path: "/system/grade/edit/" + editObj.id });
      } else if (type === "CREATE") {
        this.$router.push({ path: "/system/grade/add" });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
